import { Enums as ToolsEnums, segmentation } from "@cornerstonejs/tools";
import * as cornerstoneTools from "@cornerstonejs/tools";
import { OrganSegmentation } from "./segmentationLoader";
// @ts-ignore - Type definitions are incomplete
import { Color } from "@cornerstonejs/core/types";
import { getRenderingEngine, eventTarget, Enums } from "@cornerstonejs/core";
import { computeLabelmapData } from "@cornerstonejs/polymorphic-segmentation";
import { viewport } from "@cornerstonejs/tools/dist/esm/utilities";
import { ICamera } from "@cornerstonejs/core/dist/esm/types";
/**
 * Adds segmentation representations for all organs to the different viewports
 * @param viewportIds Object containing the IDs of all viewports
 * @param organSegmentations Array of organ segmentations to display
 */
// Global variable to store segmentations for later labelmap addition
let storedOrganSegmentations: OrganSegmentation[] = [];
let storedViewportIds: {
  axial: string;
  sagittal: string;
  coronal: string;
  volume3D: string;
} | null = null;

export async function addOrganSegmentationRepresentations(
  viewportIds: {
    axial: string;
    sagittal: string;
    coronal: string;
    volume3D: string;
  },
  organSegmentations: OrganSegmentation[]
): Promise<void> {
  // Store for later use
  storedOrganSegmentations = organSegmentations;
  storedViewportIds = viewportIds;

  const renderingEngine = getRenderingEngine("myRenderingEngine");
  let blck = false;
  let segGPUCounter = 0;
  let savedCamera: ICamera = null;
  if (renderingEngine) {
    const viewportIdsArray = [viewportIds.axial]; // viewportIds.sagittal, viewportIds.coronal
    // Set up viewport event listeners to track changes
    viewportIdsArray.forEach((viewportId) => {
      const viewport = renderingEngine.getViewport(viewportId);
      savedCamera = JSON.parse(JSON.stringify(viewport.getCamera()));
      console.log("XYZOOM ADJUSTED");
    });
  }
  setTimeout(async () => {
    await Promise.all(
      organSegmentations.map(async (organSeg) => {
        // if(organSeg.segmentationId == "GS_Bowel_Bag"){ return;}
        console.log(organSeg.color);
        // Add contour to axial
        await segmentation.addContourRepresentationToViewport(
          viewportIds.axial,
          [
            {
              segmentationId: organSeg.segmentationId,
              type: ToolsEnums.SegmentationRepresentations.Contour,
            },
          ]
        );

        // Note: Labelmaps for sagittal and coronal are now added on-demand via enableLabelmapsForSagittalCoronal()
        segGPUCounter++;
      })
    );

    segmentation.activeSegmentation.setActiveSegmentation(
      viewportIds.axial,
      null
    );
    segmentation.activeSegmentation.setActiveSegmentation(
      viewportIds.sagittal,
      null
    );
    segmentation.activeSegmentation.setActiveSegmentation(
      viewportIds.coronal,
      null
    );
    segmentation.config.style.setStyle(
      {
        type: ToolsEnums.SegmentationRepresentations.Contour,
      },
      {
        renderOutline: true,
        renderFill: false,
      }
    );
    segmentation.config.style.setStyle(
      {
        type: ToolsEnums.SegmentationRepresentations.Labelmap,
      },
      {
        renderFillInactive: false,
      }
    );
    // console.log(segmentation.hasCustomStyle({type: Enums.SegmentationRepresentations.Labelmap}))
    // return;
    // Second: Style and configure the segmentations - ONLY for axial view initially
    for (const organSeg of organSegmentations) {
      const rgba = [...organSeg.color, 0] as any; // Add alpha channel
      const outlineWidth = organSeg.owner === "GS" ? 5 : 1;

      // Style for axial (contour) - always applied
      segmentation.config.style.setStyle(
        {
          viewportId: viewportIds.axial,
          // segmentationId: organSeg.segmentationId,
          type: ToolsEnums.SegmentationRepresentations.Contour,
        },
        {
          renderOutline: true,
          renderFill: false,
          activeSegmentOutlineWidthDelta: outlineWidth,
        }
      );

      // Apply color ONLY for axial view initially
      segmentation.config.color.setSegmentIndexColor(
        viewportIds.axial,
        organSeg.segmentationId,
        1,
        rgba
      );

      // Note: Labelmap styling for sagittal and coronal is now applied in enableLabelmapsForSagittalCoronal()
    }
  }, 10);
  // First: Add segmentations to viewports in parallel

  // Set up comprehensive event listeners for actual rendering completion
  // const renderingEngine = getRenderingEngine("myRenderingEngine");
  if (renderingEngine) {
    const viewportIdsArray = [viewportIds.axial];

    // Set up viewport event listeners to track changes
    viewportIdsArray.forEach((viewportId) => {
      const viewport = renderingEngine.getViewport(viewportId);
      if (viewport) {
        const element = viewport.element;
        if (element) {
          // Listen for viewport changes
          const stateChangeHandler = (e) => {
            if (blck) return;

            // const current = e.detail.camera.position;        // [x, y, z]
            // const previous = e.detail.previousCamera.position;
            const cameraDiff = camerasDiff(e.detail.camera, savedCamera);

            if (Object.keys(cameraDiff).length == 0) {
              console.log("PREVENTED DEFAULTING");
              blck = true;
              viewport.setCamera(e.detail.previousCamera);
              // viewport.setZoom(2.0)
              queueMicrotask(() => {
                blck = false;
              });
            } else {
              console.log(cameraDiff);
            }
          };
          // Listen for proper Cornerstone events that indicate viewport changes
          if (viewportId == "CT_AXIAL")
            element.addEventListener(
              Enums.Events.CAMERA_MODIFIED,
              stateChangeHandler
            ); // Camera changes (zoom, pan)
        }
      }
    });

    // Listen for web worker progress events (for initial contour loading)
    const totalSegmentations = segGPUCounter;
    eventTarget.addEventListener(
      Enums.Events.WEB_WORKER_PROGRESS,
      (evt: any) => {
        const { progress, id, data } = evt.detail;

        if (progress == 100) {
          segGPUCounter--;
          if (segGPUCounter == 0) {
            console.log("✅ Initial contour loading completed");
          }
        }
      }
    );
  }

  // Optionally handle 3D surface representations
  // await addSurfaceRepresentations(viewportIds.volume3D, organSegmentations);
}

const EPS = 1e-6; // tolerance for floats

function camerasDiff(a: ICamera, b: ICamera) {
  const changed: Partial<Record<keyof ICamera, any>> = {};

  // Helper to compare arrays
  const arraysEqual = (arr1?: number[], arr2?: number[]) =>
    !!arr1 &&
    !!arr2 &&
    arr1.length === arr2.length &&
    arr1.every((v, i) => Math.abs(v - (arr2[i] ?? 0)) <= EPS);

  if (!arraysEqual(a.focalPoint, b.focalPoint))
    changed.focalPoint = { from: a.focalPoint, to: b.focalPoint };
  if (a.parallelProjection !== b.parallelProjection)
    changed.parallelProjection = {
      from: a.parallelProjection,
      to: b.parallelProjection,
    };
  if (Math.abs((a.parallelScale ?? 0) - (b.parallelScale ?? 0)) > EPS)
    changed.parallelScale = { from: a.parallelScale, to: b.parallelScale };
  if (Math.abs((a.scale ?? 0) - (b.scale ?? 0)) > EPS)
    changed.scale = { from: a.scale, to: b.scale };
  if (!arraysEqual(a.position, b.position))
    changed.position = { from: a.position, to: b.position };
  if (Math.abs((a.viewAngle ?? 0) - (b.viewAngle ?? 0)) > EPS)
    changed.viewAngle = { from: a.viewAngle, to: b.viewAngle };
  if (!arraysEqual(a.viewPlaneNormal, b.viewPlaneNormal))
    changed.viewPlaneNormal = {
      from: a.viewPlaneNormal,
      to: b.viewPlaneNormal,
    };
  if (!arraysEqual(a.viewUp, b.viewUp))
    changed.viewUp = { from: a.viewUp, to: b.viewUp };
  if (Math.abs((a.rotation ?? 0) - (b.rotation ?? 0)) > EPS)
    changed.rotation = { from: a.rotation, to: b.rotation };
  if (a.flipHorizontal !== b.flipHorizontal)
    changed.flipHorizontal = { from: a.flipHorizontal, to: b.flipHorizontal };
  if (a.flipVertical !== b.flipVertical)
    changed.flipVertical = { from: a.flipVertical, to: b.flipVertical };
  return changed;
}

/**
 * Add surface representations of all organs to the 3D volume view
 * @param viewportId The 3D volume viewport ID
 * @param organSegmentations Array of organ segmentations to display
 */
export async function addSurfaceRepresentations(
  viewportId: string,
  organSegmentations: OrganSegmentation[]
): Promise<void> {
  for (const organSeg of organSegmentations) {
    try {
      await segmentation.addSegmentationRepresentations(viewportId, [
        {
          segmentationId: organSeg.segmentationId,
          type: cornerstoneTools.Enums.SegmentationRepresentations.Surface,
        },
      ]);
      console.log(organSeg.owner);
      // Configure surface style for volume 3D view
      // Adjust parameters based on whether it's golden standard or student
      const fillAlpha = organSeg.owner === "GS" ? 0.4 : 0.2; // More opacity for GS
      const lineWidth = organSeg.owner === "GS" ? 2 : 1; // Thicker lines for GS

      segmentation.config.style.setStyle(
        {
          viewportId: viewportId,
          segmentationId: organSeg.segmentationId,
          type: cornerstoneTools.Enums.SegmentationRepresentations.Surface,
        },
        {
          renderFill: true,
          fillAlpha: fillAlpha,
          renderOutline: true,
          outlineWidth: lineWidth,
        }
      );

      // Set the color for the surface
      // @ts-ignore - Type casting is necessary here
      const rgba = [...organSeg.color, 255] as any; // Add alpha channel
      // @ts-ignore - Type compatibility issues with the cornerstone library
      segmentation.config.color.setSegmentIndexColor(
        viewportId,
        organSeg.segmentationId,
        1,
        rgba
      );

      // // Set initial visibility for 3D view
      // if (organSeg.visible !== undefined) {
      //   segmentation.config.visibility.setSegmentationVisibility(
      //     viewportId,
      //     organSeg.segmentationId,
      //     organSeg.visible
      //   );
      // }
    } catch (error) {
      console.warn(
        `Error adding surface representation for ${organSeg.segmentationId}:`,
        error
      );
    }
  }
}

/**
 * Toggle the visibility of a segmentation in all viewports
 * @param viewportIds Object containing the IDs of all viewports
 * @param segmentationId ID of the segmentation to toggle
 * @param visible Whether to make the segmentation visible
 */
export function toggleSegmentationVisibility(
  viewportIds: {
    axial: string;
    sagittal: string;
    coronal: string;
    volume3D: string;
  },
  segmentationId: string,
  visible: boolean
): void {
  try {
    // Configure visibility for 2D viewports
    const viewportIdsArray = [
      viewportIds.axial,
      viewportIds.sagittal,
      viewportIds.coronal,
    ];

    for (const viewportId of viewportIdsArray) {
      segmentation.config.visibility.setSegmentationRepresentationVisibility(
        viewportId,
        { segmentationId },
        visible
      );
    }

    // Trigger a render to update the display
    const renderingEngine = getRenderingEngine("myRenderingEngine");
    if (renderingEngine) {
      renderingEngine.render();
    }
  } catch (error) {
    console.warn(`Error toggling visibility for ${segmentationId}:`, error);
  }
}

/**
 * Enable labelmaps for sagittal and coronal views on-demand
 */
export async function enableLabelmapsForSagittalCoronal(
  progressCallback?: (progress: number) => void
): Promise<void> {
  if (!storedOrganSegmentations || !storedViewportIds) {
    console.warn("No stored segmentations found. Cannot enable labelmaps.");
    return;
  }

  console.log("Enabling labelmaps for sagittal and coronal views...");

  try {
    // Count GPU conversions for labelmaps (2 per segmentation: sagittal + coronal)
    let labelmapGPUCounter = storedOrganSegmentations.length;
    const totalLabelmapConversions = labelmapGPUCounter;

    // Set up progress tracking for labelmap conversions
    const labelmapProgressHandler = (evt: any) => {
      const { progress, id, data } = evt.detail;

      if (progress == 100) {
        labelmapGPUCounter--;
        const completedLabelmaps =
          totalLabelmapConversions - labelmapGPUCounter;
        const labelmapProgress = Math.round(
          (completedLabelmaps / totalLabelmapConversions) * 100
        );

        // Call the progress callback instead of console log
        if (progressCallback) {
          progressCallback(labelmapProgress);
        }

        if (labelmapGPUCounter == 0) {
          // Remove this specific event listener when done
          eventTarget.removeEventListener(
            Enums.Events.WEB_WORKER_PROGRESS,
            labelmapProgressHandler
          );
        }
      }
    };

    // Add the progress listener
    eventTarget.addEventListener(
      Enums.Events.WEB_WORKER_PROGRESS,
      labelmapProgressHandler
    );

    // Add labelmaps to sagittal and coronal for all stored segmentations
    await Promise.all(
      storedOrganSegmentations.map(async (organSeg) => {
        // Add labelmap to sagittal
        await segmentation.addLabelmapRepresentationToViewport(
          storedViewportIds.sagittal,
          [
            {
              segmentationId: organSeg.segmentationId,
              type: ToolsEnums.SegmentationRepresentations.Labelmap,
            },
          ]
        );

        // Add labelmap to coronal
        await segmentation.addLabelmapRepresentationToViewport(
          storedViewportIds.coronal,
          [
            {
              segmentationId: organSeg.segmentationId,
              type: ToolsEnums.SegmentationRepresentations.Labelmap,
            },
          ]
        );
      })
    );

    // Apply labelmap styling for sagittal and coronal
    for (const organSeg of storedOrganSegmentations) {
      const rgba = [...organSeg.color, 0] as any; // Add alpha channel
      const outlineWidth = organSeg.owner === "GS" ? 5 : 1;

      // Style for sagittal (labelmap)
      segmentation.config.style.setStyle(
        {
          segmentationId: organSeg.segmentationId,
          type: ToolsEnums.SegmentationRepresentations.Labelmap,
        },
        {
          renderOutlineInactive: true,
          renderFillInactive: false,
          outlineWidthInactive: outlineWidth,
        }
      );

      // Apply color for sagittal and coronal views
      for (const viewportId of [
        storedViewportIds.sagittal,
        storedViewportIds.coronal,
      ]) {
        segmentation.config.color.setSegmentIndexColor(
          viewportId,
          organSeg.segmentationId,
          1,
          rgba
        );
      }
    }

    // Set active segmentations to null for new views
    segmentation.activeSegmentation.setActiveSegmentation(
      storedViewportIds.sagittal,
      null
    );
    segmentation.activeSegmentation.setActiveSegmentation(
      storedViewportIds.coronal,
      null
    );

    // Trigger render
    const renderingEngine = getRenderingEngine("myRenderingEngine");
    if (renderingEngine) {
      renderingEngine.render();
    }

    console.log(
      "Labelmaps enabled for sagittal and coronal views successfully!"
    );
  } catch (error) {
    console.error("Error enabling labelmaps:", error);
  }
}
